<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14xZUgS/tc-custom/9781453263235.jpg?1734664482456" alt="This image is the cover for the book Heaven and Hell, The North and South Trilogy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Heaven and Hell, The North and South Trilogy
      </h1>
      <p class="bookDescription body article font2">
        <b>The searing conclusion to the North and South Trilogy brings the battle between the Mains and Hazards—and Confederate and Union armies—to a brilliantly satisfying end </b><br/>The last days of the Civil War bring no peace for the Main and Hazard families. As the Mains’ South smolders in the ruins of defeat, the Hazards’ North pushes blindly for relentless industrial progress. Both the nation and the families’ long-standing bond hover on the brink of destruction. In the series’ epic conclusion, Jakes expertly blends personal conflict with historical events, crafting a haunting page-turner about America’s constant change and unyielding hope.  This ebook features an illustrated biography of John Jakes including rare images from the author’s personal collection.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Jakes
      </h2>
      
      <p class="authorDescription body article">John Jakes (b. 1932), the author of more than a dozen novels, is regarded as one of today&rsquo;s most distinguished writers of historical fiction. His work includes the highly acclaimed Kent Family Chronicles series and the North and South Trilogy. Jakes&rsquo;s commitment to historical accuracy and evocative storytelling earned him the title of &ldquo;the godfather of historical novelists&rdquo; from the <I>Los Angeles Times</I> and led to a streak of sixteen consecutive <I>New York Times</I> bestsellers. Jakes has received several awards for his work and is a member of the Authors Guild and the PEN American Center. He and his wife, Rachel, live on the west coast of Florida.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4c28b994